import React, { useEffect, useContext, useState } from 'react';
import $ from 'jquery';
import DataTable from 'datatables.net';
import { LoginContext } from '../../hooks/context/LoginContext';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import Button from '../../componentes/ui/Button';
import MiSelect from '../../componentes/formulario/MiSelect';
import FormInput from '../../componentes/formulario/FormInput';
import TextArea from '../../componentes/formulario/TextArea';
import { Spinner } from 'react-bootstrap';
import { Accordion, Card } from "react-bootstrap";
import swal from 'sweetalert';
import { alertService } from '../../services/alertservice';
import { Alert } from '../../componentes/ui/Alert';
import useLogicForm from '../../hooks/useLogicForm';
import Cookies from 'universal-cookie';
import { getApiUrl, axiosPost, MiReplaceAll, getAhoraddmmyyyy, getAhorayyyymmdd, getPantDocFromNivel, setStockOptionsSelectUbi, getStockOptionsSelectUbi, getTitle, encryptData, getDecodedCookie } from '../../helpers/helperApp';
import { Fragment } from 'react';
import FormRow from '../../componentes/formulario/FormRow';
import { NavLink } from 'react-router-dom';

$.DataTable = DataTable;
const url = window.location;

function ManLog(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey, appCryptCom } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ documentos, saveDocumentos ] = useState([]);
    const [ loading, saveLoading ] = useState(false);
    const [ selectIdEquipo, saveSelectIdEquipo ] = useState(0);
    const [ inputDescripcion, saveInputDescripcion ] = useState("");
    const [ inputFecPro, saveInputFecPro ] = useState("");
    const [ inputFecUlt, saveInputFecUlt ] = useState(getAhorayyyymmdd()+" 00:00");
    const [ showModalEditar, saveShowModalEditar ] = useState(false);
    const [ selectIdEquipoModal, saveSelectIdEquipoModal ] = useState(0);
    const [ inputDescripcionModal, saveInputDescripcionModal ] = useState("");
    const [ inputFecProModal, saveInputFecProModal ] = useState("");
    const [ inputFecUltModal, saveInputFecUltModal ] = useState(getAhorayyyymmdd()+" 00:00");
    const [ lineaEditar, saveLineaEditar ] = useState(null);
    const [ acordeonPrin, saveAcordeonPrin ] = useState(null); 
    const [ mantenimientos, saveMantenimientos ] = useState([]);   

    // ***** Custom Hook - Lógica de los formularios *****
    const { loadReg, saveLoadReg } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{ 
                    document.title = getTitle(confPantalla.config.trad, confPantalla.manlog.title);                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true);
                        loadDocumentosTable();
                        loadMantenimientosTable();                           
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");

                // Token cancelación axios al desmontar componentes
                source.cancel();
        } 

    },[confPantalla])

    const loadDocumentosTable = async () => {
        
        saveLoading(true);
        
        const data = new FormData();                            
        data.append("validacion", apiKey());        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlog.controles.datatabledocumentos.getdata, data, source.token);
               
        if( typeof respuesta.data !== "string" ){
            saveDocumentos(respuesta.data);            
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }
        
        saveLoading(false);
    }

    const loadMantenimientosTable = async () => {
        
        saveLoading(true);
        
        const data = new FormData();                            
        data.append("validacion", apiKey());        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlog.controles.datatablemantenimientos.getdata, data, source.token);
               
        if( typeof respuesta.data !== "string" ){
            saveMantenimientos(respuesta.data);            
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }
        
        saveLoading(false);
    }

    const createNew = () => {
        if (new Date(inputFecUlt) > new Date(inputFecPro)){
            // Error la fecha de próxima ejecución debe ser posterior a la de última ejecución
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.manlog.txterrordates.title}`, {autoClose: true});   
            return;
        }
        
        swal({
            title: confPantalla.manlog.swal.title,
            text: confPantalla.manlog.swal.text.title,
            icon: "warning",
            buttons: {
                cancel : {text: confPantalla.manlog.swal.btncancelar.title, className:'btn btn-flat mr-1 btn-outline-secondary', visible: true},
                confirm : {text: confPantalla.manlog.swal.btnaceptar.title, className:'btn btn-flat btn-outline-success btnSwalSuccess'}
            } 
        }).then(confirmacion => {
            if(confirmacion){
                createNewAction();
            }
        })
        
        
    }

    const createNewAction = async () => {
        saveLoading(true);
        
        const data = new FormData();                            
        data.append("validacion", apiKey());
        data.append("idequ", selectIdEquipo);
        data.append("nom1", inputDescripcion);
        data.append("fecpro", inputFecPro);
        data.append("fecult", inputFecUlt);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlog.controles.createdoc, data, source.token);
               
        if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }else{
            saveSelectIdEquipo(0);
            saveInputDescripcion("");
            saveInputFecUlt(getAhorayyyymmdd()+" 00:00");
            saveInputFecPro("");
        }
        
        await loadDocumentosTable();

        saveLoading(false);
    }


    const showEditarLinea = (e, rowData) =>{
        saveLineaEditar(rowData);        
        saveSelectIdEquipoModal(rowData.idequ);
        saveInputDescripcionModal(rowData.descripcionNoHtml);
        saveInputFecUltModal(rowData.fecult);
        saveInputFecProModal(rowData.fecpro);
        saveShowModalEditar(true);
    }

    const accionBtnEditar = async () => {
        if (new Date(inputFecUltModal) > new Date(inputFecProModal)){
            // Error la fecha de próxima ejecución debe ser posterior a la de última ejecución
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.manlog.txterrordates.title}`, {autoClose: true});   
            return;
        }

        saveLoading(true);
        
        const data = new FormData();                            
        data.append("validacion", apiKey());
        data.append("iddoc", lineaEditar.id);
        data.append("idequ", selectIdEquipoModal);
        data.append("nom1", inputDescripcionModal);
        data.append("fecpro", inputFecProModal);
        data.append("fecult", inputFecUltModal);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.manlog.modaleditar.editar.senddata, data, source.token);
               
        if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        }
        
        await loadDocumentosTable();
        saveLoading(false);
        saveShowModalEditar(false);

    }
    
    const open = (e, rowData) => {          
        let ruta = rowData.ruta;
        const esUrl = ruta.startsWith('http://') || ruta.startsWith('https://') || ruta.startsWith('www.');
        const baseUrl = getApiUrl(window.location.origin);

        try {            
            if (ruta.startsWith('www.')) {
                ruta = `https://${ruta}`;
            }

            if (esUrl) {
                // Intentar abrir la URL en una nueva pestaña
                const nuevaVentana = window.open(ruta, '_blank');
                if (!nuevaVentana) {
                    alertService.error(`<i class="fal fa-times-octagon mr-1"></i> ${confPantalla.manlog.txterroropen.title}`, { autoClose: true });
                }
            } else {
                // Comprobar si es un archivo local o una ruta relativa
                const archivoUrl = ruta.startsWith('file://') ? ruta : `${baseUrl}${ruta}`;
                const nuevaVentana = window.open(archivoUrl, '_blank');
                if (!nuevaVentana) {
                    alertService.error(`<i class="fal fa-times-octagon mr-1"></i> ${confPantalla.manlog.txterroropen.title}`, { autoClose: true });
                }
            }
        } catch (error) {            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i> ${confPantalla.manlog.txterroropen.title}`, { autoClose: true });
        }
    }


    const handleSelect= (selectedItem, nameOfComponent, saveData) => {
        if( selectedItem ){
            saveData(selectedItem.value) 
        }else{
            saveData(0)
        }
    }

    const handleInput = (e, save) => {     
        save(e.target.value)
    }

    const toogleAcordeon = (id) => {
        if( acordeonPrin == id ){
            saveAcordeonPrin(null);                    
        }else{
            saveAcordeonPrin(id);                    
        }        
    }

    
    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
            </div>   
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Alert fondo={true} />
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">                
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                            <Section
                                tituloenhtml={true}
                                titulo={ confPantalla.manlog.section.titulo }  
                                icono={ confPantalla.manlog.section.icono } 
                                col={ confPantalla.manlog.section.col }                                
                            >
                            <FormRow>
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { selectIdEquipo  }   
                                    loading=     { loading ? true : false }
                                    id=          { confPantalla.manlog.controles.idequ.id }    
                                    name=        { confPantalla.manlog.controles.idequ.name }   
                                    label=       { confPantalla.manlog.controles.idequ.label }    
                                    placeholder= { confPantalla.manlog.controles.idequ.placeholder }
                                    col=         { confPantalla.manlog.controles.idequ.col } 
                                    isClearable= { confPantalla.manlog.controles.idequ.isclearable }
                                    isSearchable={ confPantalla.manlog.controles.idequ.issearchable }
                                    dataType=    { confPantalla.manlog.controles.idequ.datatype }
                                    data=        { confPantalla.manlog.controles.idequ.data }
                                    required=    { confPantalla.manlog.controles.idequ.required } 
                                    disabled=  { confPantalla.manlog.controles.idequ.disabled }
                                    readOnly =   { confPantalla.manlog.controles.idequ.readonly }
                                    disablethisid={confPantalla.manlog.controles.idequ.disablethisid}
                                    disableids={confPantalla.manlog.controles.idequ.disableids}                                    
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveSelectIdEquipo) }
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { inputDescripcion }
                                    loading=    { loading ? true : false }
                                    id=         { confPantalla.manlog.controles.descripcion.id }   
                                    type=       { confPantalla.manlog.controles.descripcion.type }  
                                    name=       { confPantalla.manlog.controles.descripcion.name }   
                                    label=      { confPantalla.manlog.controles.descripcion.label }                                                       
                                    placeholder={ confPantalla.manlog.controles.descripcion.placeholder }    
                                    col=        { confPantalla.manlog.controles.descripcion.col } 
                                    required=   { confPantalla.manlog.controles.descripcion.required }
                                    readonly=   { confPantalla.manlog.controles.descripcion.readonly }
                                    disabled=   { confPantalla.manlog.controles.descripcion.disabled }
                                    change=     { e => handleInput(e, saveInputDescripcion) }
                                    onBlur=     {null}
                                    autoCompleteData = {documentos}
                                    saveSuggestion={saveInputDescripcion} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { inputFecUlt }
                                    loading=    { loading ? true : false }
                                    id=         { confPantalla.manlog.controles.fecult.id }   
                                    type=       { confPantalla.manlog.controles.fecult.type }  
                                    name=       { confPantalla.manlog.controles.fecult.name }   
                                    label=      { confPantalla.manlog.controles.fecult.label }                                                       
                                    placeholder={ confPantalla.manlog.controles.fecult.placeholder }    
                                    col=        { confPantalla.manlog.controles.fecult.col } 
                                    required=   { confPantalla.manlog.controles.fecult.required }
                                    readonly=   { confPantalla.manlog.controles.fecult.readonly }
                                    disabled=   { confPantalla.manlog.controles.fecult.disabled }
                                    change=     { e => handleInput(e, saveInputFecUlt) }
                                    onBlur=     {null} 
                                />                                 
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { inputFecPro }
                                    loading=    { loading ? true : false }
                                    id=         { confPantalla.manlog.controles.fecpro.id }   
                                    type=       { confPantalla.manlog.controles.fecpro.type }  
                                    name=       { confPantalla.manlog.controles.fecpro.name }   
                                    label=      { confPantalla.manlog.controles.fecpro.label }                                                       
                                    placeholder={ confPantalla.manlog.controles.fecpro.placeholder }    
                                    col=        { confPantalla.manlog.controles.fecpro.col } 
                                    required=   { confPantalla.manlog.controles.fecpro.required }
                                    readonly=   { confPantalla.manlog.controles.fecpro.readonly }
                                    disabled=   { confPantalla.manlog.controles.fecpro.disabled }
                                    change=     { e => handleInput(e, saveInputFecPro) }
                                    onBlur=     {null} 
                                /> 
                            </FormRow>
                            <p className="font-italic text-center">{ confPantalla.manlog.txtrequired.title }</p>                                
                            <Button 
                                clases={ "col-12 mt-2 mb-4" }
                                estadoForm={ loading ? "disabled" : "" }
                                color={ "success" }  
                                type="button" 
                                icono={ "" }   
                                id="btnnew"     
                                texto={ confPantalla.manlog.controles.btnnew.title }   
                                accion={ createNew } 
                                disabled={ inputDescripcion == "" || inputFecUlt == "" || loading == true ? true : false }
                            /> 
                            {   loading == true ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }
                            <Accordion defaultActiveKey={""}  >
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => toogleAcordeon('0')} className={ acordeonPrin == "0" ? "activeAcordeon" : "" }>
                                        <i className={ confPantalla.manlog.mantenimientos.icono } ></i> { confPantalla.manlog.mantenimientos.titulo }
                                        {
                                            acordeonPrin == "0"
                                            ?
                                                <i className={"fal fa-chevron-up float-right fa-2x"} ></i>
                                            :
                                                <i className={"fal fa-chevron-down float-right fa-2x"} ></i>
                                        }
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="0" className={"slowAcordeon"} >
                                        <Card.Body>                                        
                                            <MiDataTable 
                                                estadoForm= { "" }
                                                formulario={ {id:0} }
                                                id={"manlogmant"}
                                                columnas={confPantalla.manlog.controles.datatablemantenimientos.columns}
                                                data={mantenimientos}
                                                buttons={confPantalla.manlog.controles.datatablemantenimientos.buttons}
                                                ordering={confPantalla.manlog.controles.datatablemantenimientos.ordering}
                                                order={confPantalla.manlog.controles.datatablemantenimientos.order}
                                                searching={confPantalla.manlog.controles.datatablemantenimientos.searching}
                                                paging={confPantalla.manlog.controles.datatablemantenimientos.paging}
                                                select={confPantalla.manlog.controles.datatablemantenimientos.select}
                                                pagelength={confPantalla.manlog.controles.datatablemantenimientos.pagelength}
                                                // saveLoadingTable={ saveLoading }
                                                // loadingTable={loading}
                                                columnactions={confPantalla.manlog.controles.datatablemantenimientos.columnactions.title}
                                                linkColumns={confPantalla.manlog.controles.datatablemantenimientos.linkColumns}
                                                traduction={confPantalla.config.trad.components.datatable}
                                                functionClickTd={ open }                                
                                            />   
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="1" onClick={() => toogleAcordeon('1')} className={ acordeonPrin == "1" ? "activeAcordeon" : "" }>
                                        <i className={ confPantalla.manlog.historicos.icono } ></i> { confPantalla.manlog.historicos.titulo }
                                        {
                                            acordeonPrin == "1"
                                            ?
                                                <i className={"fal fa-chevron-up float-right fa-2x"} ></i>
                                            :
                                                <i className={"fal fa-chevron-down float-right fa-2x"} ></i>
                                        }
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="1" className={"slowAcordeon"} >
                                        <Card.Body>                                        
                                            <MiDataTable 
                                                estadoForm= { "" }
                                                formulario={ {id:0} }
                                                id={"manlog"}
                                                columnas={confPantalla.manlog.controles.datatabledocumentos.columns}
                                                data={documentos}
                                                buttons={confPantalla.manlog.controles.datatabledocumentos.buttons}
                                                ordering={confPantalla.manlog.controles.datatabledocumentos.ordering}
                                                order={confPantalla.manlog.controles.datatabledocumentos.order}
                                                searching={confPantalla.manlog.controles.datatabledocumentos.searching}
                                                paging={confPantalla.manlog.controles.datatabledocumentos.paging}
                                                select={confPantalla.manlog.controles.datatabledocumentos.select}
                                                pagelength={confPantalla.manlog.controles.datatabledocumentos.pagelength}
                                                // saveLoadingTable={ saveLoading }
                                                // loadingTable={loading}
                                                columnactions={confPantalla.manlog.controles.datatabledocumentos.columnactions.title}
                                                linkColumns={confPantalla.manlog.controles.datatabledocumentos.linkColumns}
                                                traduction={confPantalla.config.trad.components.datatable}
                                                functionClickTd={ cookies.get('nivel') <= '2' ? showEditarLinea : null }                                
                                            />   
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                {
                    showModalEditar == true
                    ?
                    <Modal
                        show={showModalEditar}
                        onHide={ () => saveShowModalEditar(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w"                                             
                    > 
                        <Modal.Header closeButton>
                            <h4>{confPantalla.manlog.modaleditar.header.title}</h4>
                        </Modal.Header>                         
                        <Modal.Body>
                        <FormRow>
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { selectIdEquipoModal  }   
                                    loading=     { loading ? true : false }
                                    id=          { confPantalla.manlog.modaleditar.idequ.id }    
                                    name=        { confPantalla.manlog.modaleditar.idequ.name }   
                                    label=       { confPantalla.manlog.modaleditar.idequ.label }    
                                    placeholder= { confPantalla.manlog.modaleditar.idequ.placeholder }
                                    col=         { confPantalla.manlog.modaleditar.idequ.col } 
                                    isClearable= { confPantalla.manlog.modaleditar.idequ.isclearable }
                                    isSearchable={ confPantalla.manlog.modaleditar.idequ.issearchable }
                                    dataType=    { confPantalla.manlog.modaleditar.idequ.datatype }
                                    data=        { confPantalla.manlog.modaleditar.idequ.data }
                                    required=    { confPantalla.manlog.modaleditar.idequ.required } 
                                    disabled=  { confPantalla.manlog.modaleditar.idequ.disabled }
                                    readOnly =   { confPantalla.manlog.modaleditar.idequ.readonly }
                                    disablethisid={confPantalla.manlog.modaleditar.idequ.disablethisid}
                                    disableids={confPantalla.manlog.modaleditar.idequ.disableids}                                    
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveSelectIdEquipoModal) }
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { inputDescripcionModal }
                                    loading=    { loading ? true : false }
                                    id=         { confPantalla.manlog.modaleditar.descripcion.id }   
                                    type=       { confPantalla.manlog.modaleditar.descripcion.type }  
                                    name=       { confPantalla.manlog.modaleditar.descripcion.name }   
                                    label=      { confPantalla.manlog.modaleditar.descripcion.label }                                                       
                                    placeholder={ confPantalla.manlog.modaleditar.descripcion.placeholder }    
                                    col=        { confPantalla.manlog.modaleditar.descripcion.col } 
                                    required=   { confPantalla.manlog.modaleditar.descripcion.required }
                                    readonly=   { confPantalla.manlog.modaleditar.descripcion.readonly }
                                    disabled=   { confPantalla.manlog.modaleditar.descripcion.disabled }
                                    change=     { e => handleInput(e, saveInputDescripcionModal) }
                                    onBlur=     {null}
                                    // autoCompleteData = {documentos}
                                    // saveSuggestion={saveInputDescripcion} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { inputFecUltModal }
                                    loading=    { loading ? true : false }
                                    id=         { confPantalla.manlog.modaleditar.fecult.id }   
                                    type=       { confPantalla.manlog.modaleditar.fecult.type }  
                                    name=       { confPantalla.manlog.modaleditar.fecult.name }   
                                    label=      { confPantalla.manlog.modaleditar.fecult.label }                                                       
                                    placeholder={ confPantalla.manlog.modaleditar.fecult.placeholder }    
                                    col=        { confPantalla.manlog.modaleditar.fecult.col } 
                                    required=   { confPantalla.manlog.modaleditar.fecult.required }
                                    readonly=   { confPantalla.manlog.modaleditar.fecult.readonly }
                                    disabled=   { confPantalla.manlog.modaleditar.fecult.disabled }
                                    change=     { e => handleInput(e, saveInputFecUltModal) }
                                    onBlur=     {null} 
                                />                                 
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { inputFecProModal }
                                    loading=    { loading ? true : false }
                                    id=         { confPantalla.manlog.modaleditar.fecpro.id }   
                                    type=       { confPantalla.manlog.modaleditar.fecpro.type }  
                                    name=       { confPantalla.manlog.modaleditar.fecpro.name }   
                                    label=      { confPantalla.manlog.modaleditar.fecpro.label }                                                       
                                    placeholder={ confPantalla.manlog.modaleditar.fecpro.placeholder }    
                                    col=        { confPantalla.manlog.modaleditar.fecpro.col } 
                                    required=   { confPantalla.manlog.modaleditar.fecpro.required }
                                    readonly=   { confPantalla.manlog.modaleditar.fecpro.readonly }
                                    disabled=   { confPantalla.manlog.modaleditar.fecpro.disabled }
                                    change=     { e => handleInput(e, saveInputFecProModal) }
                                    onBlur=     {null} 
                                /> 
                            </FormRow>
                            <p className="font-italic text-center">{ confPantalla.manlog.txtrequired.title }</p>
                            {   loading ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }                            
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>
                                <button 
                                        className="btn btn-success mt-1 mr-1"
                                        onClick={ accionBtnEditar }
                                        disabled={inputDescripcionModal == "" || inputFecUltModal == "" || loading == true ? true : false}                                        
                                >
                                    {confPantalla.manlog.modaleditar.btnaceptar.title}
                                </button>
                                <button 
                                        className="btn btn-danger mt-1"
                                        onClick={ () => saveShowModalEditar(false) }                                        
                                >
                                    {confPantalla.manlog.modaleditar.btncancelar.title}
                                </button>                                            
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                    :
                        null
                }
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default ManLog;